import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';

const options = { day: "numeric", month: "numeric", year: "numeric" }; // 15/07/2018
const shortYearOptions = { day: "numeric", month: "numeric" }; // 15/07/18
const withTimeOptions = { day: "numeric", month: "numeric", year: "numeric", hour: "numeric", minute: "numeric" };


const tooltipOptions = { weekday: "long", day: "numeric", month: "long", year: "numeric", hour: "numeric", minute: "numeric", second: "numeric" };

class Datetime extends React.Component {
    render() {
        const { datetime, withTime, placeholder, shortYear, withTooltip } = this.props;

        if (datetime) {
            let opts = options;

            if (withTime)
                opts = withTimeOptions;
            else if (shortYear)
                opts = shortYearOptions;

            var formatted = new Date(datetime).toLocaleDateString("fr-FR", opts);

            if (withTooltip) {

                var formattedTooltip = new Date(datetime).toLocaleDateString("fr-FR", tooltipOptions);

                return (<Tooltip title={formattedTooltip}><span>{formatted}</span></Tooltip>);

            }

            return (<React.Fragment>{formatted}</React.Fragment>);
        }

        if (placeholder) {
            return placeholder;
        }

        return null;
    }
}

Datetime.propTypes = {
    datetime: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
    placeholder: PropTypes.string,

    withTime: PropTypes.bool,
    shortYear: PropTypes.bool,
    withTooltip: PropTypes.bool
};

export default Datetime;